import { buildRequest } from "./initWebSocket";
import { socketSendMessageEvent } from "./socketEvents";

// A single helper function for all APIs
function callApi(service, method, payload = {}) {
  const req = buildRequest(service, method, payload);
  return socketSendMessageEvent(req);
};

const webSocketApiService = {
  GetUserDomains: () =>
    callApi("UserService", "GetUserDomains"),

  GetBotSubscriptionsInfo: (selectedDomain) =>
    callApi("UserService", "GetBotSubscriptionsInfo", { selectedDomain}),
  
  UploadFile: (payload) =>
    callApi("FileService", "UploadFile", payload),

  AgentGuardService:(payload) => 
  callApi('AgentGuardService','Execute',payload),

  GetWSConnectionId:() => callApi('AuthSessionService','GetWSConnectionId'),
  GetFavouriteConversations: (selectedDomain) => callApi('ConversationService','GetFavouriteConversations',selectedDomain),
  UpdateFavourites: (data) => callApi('ConversationService','UpdateFavourites',data),
  GetCatalog: (params) => callApi('ConversationService','GetCatalog',params),
  SubscribeBot: (params) => callApi('UserService','SubscribeBot',params),
  UpdateLastLoggedInDomain: (data) => callApi('UserService','UpdateLastLoggedInDomain',data),
  // FileService 
  GetSignedUrlsForUpload: (payload) => callApi("FileService", "GetSignedUrlsForUpload", payload),
  CreateThumbnailForFile: (payload) => callApi('FileService', 'CreateThumbnailForFile', payload),
  // Contacts
  GetContacts: (data) => callApi('UserService','GetContacts',data),
  Find: (data) => callApi('ContactsService','Find',data),
  Add: (data) => callApi('ContactsService','Add',data),
  Remove: (data) => callApi('ContactsService','Remove',data),
  Update: (data) => callApi('ContactsService','Update',data),
  Invite: (data) => callApi('ContactsService','Invite',data),
  Accept: (data) => callApi('ContactsService','Accept',data),
  Ignore: (data) => callApi('ContactsService','Ignore',data),
  GetCallHistoryForContact: (data) => callApi('UserService','GetCallHistoryForContact',data),
  // Group
  Edit: (data) => callApi('ChannelsService','Edit',data),
  Create: (data) => callApi('ChannelsService','Create',data),
  AddParticipants: (data) => callApi('ChannelsService','AddParticipants',data),
  GetSubscribed: (data) => callApi('ChannelsService','GetSubscribed',data),
  GetUnsubscribed: (data) => callApi('ChannelsService','GetUnsubscribed',data),
  GetPendingParticipants: (data) => callApi('ChannelsService','GetPendingParticipants',data),
  GetParticipants: (data) => callApi('ChannelsService','GetParticipants',data),
  UpdateParticipants: (data) => callApi('ChannelsService','UpdateParticipants',data),
  DeleteChannel: (data) => callApi('ChannelsService','DeleteChannel',data),
  UpdateChannelAdmins: (data) => callApi('ChannelsService','UpdateChannelAdmins',data),
  ChangeOwner: (data) => callApi('ChannelsService','ChangeOwner',data),
  
  // Timeline
  GetTimeline: (data) => callApi('ConversationService','GetTimeline',data),
  SubscribeDomain: (data) => callApi('UserService','SubscribeDomain',data),

  //Profile
  UpdateUserProfile: (data) => callApi('UserService','UpdateUserProfile',data),
  getShipDetails: (data) => callApi('UserService','getShipDetails',data),
  GetLevel3Ranks: (data) => callApi('UserService','GetLevel3Ranks',data),
  DeleteUser: (data) => callApi('AuthService','DeleteUser',data),

  //Payment 
  ConfirmPayment: (data) => callApi('PaymentService','ConfirmPayment',data),
  InitiatePayment: (data) => callApi('PaymentService','InitiatePayment',data),

  //Chart
  GetMongoDashboardData: (data) => callApi('UserService','GetMongoDashboardData',data),

  //Web Push Notifications
  RegisterWebApp: (data) => callApi('UserService','RegisterWebApp',data),
  //Calls
  GetPaginatedCallHistory: (data) => callApi('UserService','GetPaginatedCallHistory',data),
  SendVoipPushNotification: (data) => callApi('UserService','SendVoipPushNotification',data),
  SetUserAvailableForCall: () => callApi('UserService','SetUserAvailableForCall'),
  

};

export default webSocketApiService;
